import cloneDeep from 'lodash/cloneDeep'
import {
    ADD_INVENTORY_ITEMS, DELETE_INVENTORY_ITEMS, UPDATE_INVENTORY_ITEM, INIT_INVENTORY,
} from '../../actions/game/inventory.actions'
import itemHelper from '../../../utils/itemHelper'

const { createItemBase } = itemHelper

const initialState = []
const initialInventory = [
    createItemBase('DAGGER_001'),
]

const rosterReducer = (state = initialState, action) => {
    const { payload } = action

    switch (action.type) {
        case ADD_INVENTORY_ITEMS: {
            const { items } = payload
            const newItems = items.map(item => (createItemBase(item)))
            return [...cloneDeep(state), ...newItems]
        }

        case DELETE_INVENTORY_ITEMS: {
            return state // ToDo
        }

        case UPDATE_INVENTORY_ITEM: {
            return state // ToDo
        }

        case INIT_INVENTORY: {
            return initialInventory
        }

        default: {
            return state
        }
    }
}

export default rosterReducer
